import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uniqueValues'
})
export class UniqueValuesPipe implements PipeTransform {

  transform(value: any, args: any): any {

    if (value) {
      const uniqueValue = new Set();
      value.forEach(d => {
        if (d[args]) {
        d[args].forEach(m => {
          if (!uniqueValue.has(m.name)) {
            uniqueValue.add(m.name);
          }
        });
      }
      });

      return [...uniqueValue];
    }

    return [];
  }

}
